import {Injectable} from '@angular/core';
import {
	MatSnackBar,
	MatSnackBarConfig,
	MatSnackBarRef,
	SimpleSnackBar
} from '@angular/material/snack-bar';

export enum SnackEnum {
	SUCCESS = 'success-snackbar',
	ERROR = 'error-snackbar',
	WARNING = 'warning-snackbar',
	INFO = 'info-snackbar'
}

@Injectable({
	providedIn: 'root'
})
export class SnackbarService {
	private snackBarRefs: MatSnackBarRef<SimpleSnackBar>[] = [];

	constructor(private snackBar: MatSnackBar) {}

	showSuccess(message: string, duration?: number) {
		this.show(message, duration, SnackEnum.SUCCESS);
	}

	showError(message: string, duration?: number) {
		this.show(message, duration, SnackEnum.ERROR);
	}

	showWarning(message: string, duration?: number) {
		this.show(message, duration, SnackEnum.WARNING);
	}

	showInfo(message: string, duration?: number) {
		this.show(message, duration, SnackEnum.INFO);
	}

	private show(
		message: string,
		duration: number = 2000,
		type: SnackEnum = SnackEnum.INFO
	) {
		const config = new MatSnackBarConfig();
		config.duration = duration; // Duration in milliseconds
		config.panelClass = [type];
		const snackBarRef = this.snackBar.open(message, 'Close', config);

		this.snackBarRefs.push(snackBarRef);

		// Remove the reference when the snackbar is dismissed
		snackBarRef.afterDismissed().subscribe(() => {
			const index = this.snackBarRefs.indexOf(snackBarRef);
			if (index >= 0) {
				this.snackBarRefs.splice(index, 1);
			}
		});
	}
}
